import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Routes that own their scroll behavior — exclude from global reset.
const SKIP_PATHS: RegExp[] = [/^\/now-playing/];

// Routes carry `?scrollTo=<anchor>` to scrollIntoView a specific element
// after mount (e.g. /story/:id?scrollTo=rating from NowPlayingMenu's
// "Bewerten"). Resetting to 0,0 first would cause a visible jump-then-
// smooth-scroll flicker, so any presence of the param skips the reset
// and lets the destination route own the scroll.
export function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (SKIP_PATHS.some((p) => p.test(pathname))) return;
    const params = new URLSearchParams(search);
    if (params.has('scrollTo')) return;
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
}
